import { z } from 'zod';
import type { BattleAnswerMemo } from '../model/battle-room-store';

const memoSchema = z.object({
  code: z.string(),
  key: z.string(),
  titleId: z.string(),
  remainingMs: z.number().min(0).max(30000),
});
const storageKey = (owner: string) => `uznali:battle-answer:${owner}`;
export const readBattleAnswer = (owner: string, code: string, key: string): BattleAnswerMemo | undefined => {
  try {
    const result = memoSchema.safeParse(JSON.parse(sessionStorage.getItem(storageKey(owner)) ?? 'null'));
    if (result.success && result.data.code === code && result.data.key === key) return result.data;
  } catch {
    /* A missing UI cache cannot affect server scoring. */
  }
  return undefined;
};
export const writeBattleAnswer = (owner: string, code: string, key: string, value: BattleAnswerMemo) => {
  try {
    sessionStorage.setItem(storageKey(owner), JSON.stringify({ code, key, ...value }));
  } catch {
    /* In-memory state remains available. */
  }
};
